<template lang="pug">
.base-option(:class="[disabled ? '' : 'cursor-pointer', isSelected ? 'bg-form-item-placeholder' : '']", @click.stop="onClick")
  slot(:label="label", :value="value", :data="data", :isSelected="isSelected")
    span.truncate {{ label }}
</template>

<script setup>
import { inject, computed, onMounted, onUnmounted } from 'vue'

const props = defineProps({
  value: undefined,
  label: String,
  data: [String, Object],
  disabled: Boolean,
})

const selectContext = inject('Select')

const isSelected = computed(() => {
  return selectContext.isSelected(props.value)
})

const onClick = () => {
  if (props.disabled) return

  // 調用父組件的選擇方法
  selectContext.onSelect(props.value)
}

// 組件掛載時註冊自己
onMounted(() => {
  selectContext.registerOption({
    value: props.value,
    label: props.label,
    data: props.data,
    disabled: props.disabled,
  })
})

// 組件卸載時取消註冊
onUnmounted(() => {
  selectContext.unregisterOption(props.value)
})
</script>

<style scoped lang="scss"></style>
